import React from "react";
import { Outlet, Navigate, useLocation, NavLink, useParams } from "react-router-dom";
import { cn } from "../../../../lib/utils/cn";
import { JobTabsConfigSelect } from "@/dentlab/src/forms/form-components/job-tabs-config-select.component";
import { useCentralStore } from "@/dentlab/src/store/Central";

export const ClientSettingsPage: React.FC = () => {
	const location = useLocation();
	const { clientId } = useParams();
	const basePath = `/client/${clientId}/einstellungen`;
	const isRootPath = location.pathname === basePath;

	const { updateClientField, client } = useCentralStore((state) => ({
		updateClientField: state.updateClientField,
		client: state.client,
	}));

	const menuItems = [
		{ path: "allgemeine-informationen", label: "Allgemeine Informationen" },
		{ path: "rechnungen", label: "Verrechnung" },
		{ path: "dokumente", label: "Dokumente" },
		{ path: "behandlerliste", label: "Behandlerliste" },
		{ path: "verbindung", label: "dentCONNECT" },
	];

	if (isRootPath) {
		return <Navigate to={`${basePath}/allgemeine-informationen`} replace />;
	}

	return (
		<div className="flex h-full">
			<nav className="w-64 h-full border-r border-gray-200 bg-gray-50">
				<ul className="py-2">
					{menuItems.map((item) => (
						<li key={item.path}>
							<NavLink
								to={`${basePath}/${item.path}`}
								className={({ isActive }) =>
									cn(
										"block px-4 py-2 text-sm hover:bg-gray-100 transition-colors",
										isActive && "bg-white font-medium border-l-2 border-blue-500"
									)
								}
							>
								{item.label}
							</NavLink>
						</li>
					))}
				</ul>
				<div className="px-4 py-4 border-t border-gray-200">
					<div className="text-sm mb-2">
						Auftragslayout
					</div>
					<JobTabsConfigSelect
						value={client?.default_job_tabs_config_id || null}
						onChange={async (value) => {
							await updateClientField("default_job_tabs_config_id", value);
						}}
						emptyLabel="Labor-Standard"
						width="100%"
					/>
				</div>
			</nav>
			<div className="flex-1 overflow-auto">
				<Outlet />
			</div>
		</div>
	);
};